import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import TabMenu from "./TabMenu.tsx";
import RichTextEditor from "./RichTextEditor.tsx";
import { fetchContent } from "../../../redux/features/contentManagement/contentSlice.tsx";
import { RootState } from "../../../redux/store.tsx";
import { useAppDispatch } from "../../../hooks/useAppDispatch.tsx";
import EditIcon from "@mui/icons-material/Edit";
import { useAppSelector } from "../../../hooks/useAppSelector.tsx";

const ContactUs: React.FC = () => {
  const dispatch = useAppDispatch();
  const { content, isLoading } = useAppSelector(
    (state: RootState) => state.content
  );

  const [isEditing, setIsEditing] = useState(false);
  const [editorValue, setEditorValue] = useState<string>("");
  const [selectedMainTab, setSelectedMainTab] = useState<string>("contactUs");
  const [selectedSubcategory, setSelectedSubcategory] = useState<string>("en");

  const profile = useAppSelector((state) => state.profile.data);
  const hasEditPermission = useMemo(() => {
    if (profile?.data?.role !== "SUB_ADMIN") {
      return true;
    }
    return profile?.data?.editModule?.includes("content-management");
  }, [profile?.data?.role, profile?.data?.editModule]);

  useEffect(() => {
    // Fetch the content for the default language on initial load and when language changes
    dispatch(fetchContent({ type: 5, lang: selectedSubcategory }));
  }, [dispatch, selectedSubcategory]);

  useEffect(() => {
    setEditorValue(content);
  }, [content]);


  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSaveSuccess = () => {
    setIsEditing(false);
  };

  const handleSubcategoryChange = (subcategory: string) => {
    if (subcategory !== selectedSubcategory) {
      setSelectedSubcategory(subcategory);
    }
  };

  return (
    <div className="py-6 px-9">
      <TabMenu
        selectedTab={selectedMainTab}
        selectedSubcategory={selectedSubcategory}
        onSubcategoryChange={handleSubcategoryChange}
      />
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
          <CircularProgress />
        </Box>
      ) : (
        <div className="mt-6 border rounded-lg shadow h-fit">
          <div className="flex justify-between items-center bg-[#E3F7F9] p-4 h-16 rounded-t-lg">
            <h2 className="font-bold text-2xl text-[#004135]">
              {selectedMainTab.charAt(0).toUpperCase() + selectedMainTab.slice(1)}
            </h2>
            {!isEditing && !isLoading && hasEditPermission && (
              <Button
                variant="contained"
                style={{ backgroundColor: "#3BC1CD", color: "#FFF", fontWeight: "700", fontSize: "16px" }}
                onClick={handleEditClick}
                disabled={isLoading}
              >
                <EditIcon /> <span className="mx-2">Edit</span>
              </Button>
            )}
          </div>
          <div className="p-4">
            {isEditing ? (
              <RichTextEditor
                value={editorValue}
                onCancel={handleCancel}
                placeholder={`Enter ${selectedMainTab} details`}
                type={5}
                onSaveSuccess={handleSaveSuccess}
                lang={selectedSubcategory} 
              />
            ) : (
              <div className="text-gray-600 htmlContent" dangerouslySetInnerHTML={{ __html: editorValue }} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;